/*
 * @Descripttion: input输入框（区间类型）
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState } from 'react';
import { NumberPicker, Select } from '@alifd/next';
import styles from './index.module.scss';

// 规定出所有可能的选择类型
const sectionType = [
  {
    label: '区间',
    key: 'RANGE',
  },
  {
    label: '大于等于',
    key: 'RANGEGT',
  },
  {
    label: '小于等于',
    key: 'RANGELT',
  },
];

/**
 * opType 在dayType数组范围内
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 * tagItem.value[0].type: 数量1  金额2~需要乘100传值，前端展示元，后端计算分  可输入负数3~积分余额都可输负数 金额但不需要转换单位4~大概只为了给云鹿的陆泽标签人群用 可以输入小数5~
 */
const TagSection = ({ tagItem = {}, changeData = (data) => { } }) => {
  const [type, setType] = useState(tagItem.opType ? tagItem.opType : 'RANGE'); // 枚举类型见dayType
  const [data, setData] = useState(tagItem.opType === 'RANGE' ? [tagItem.opValue?.extra_map?.min_price ?? '', tagItem.opValue?.extra_map?.max_price ?? ''] : [0, tagItem.opValue?.extra_map?.price ?? '']); // 区间的值更改前或后面的值适合用数组形式改变，所以自己内部维护一个数组

  const handleData = (d1 = '', d2 = '') => {
    const obj = {
      label_id: tagItem?.id,
      param_list: [
        {
          param_id: type === 'RANGE' ? [1] : type === 'RANGEGT'  ? [2] : [3] // 介于1 大于等于 2 小于等于 3
        }
      ],
    }
    const extra_map = type === 'RANGE' ? {
      min_price: d1,
      max_price: d2
    } : {
      "price": d2
    }
    return {
      ...obj,
      extra_map
    }
  }

  /**
   * @description: 改变传递的区间类型
   * @param {*} val
   * @return {*}
   */
  const changeType = (val) => {
    setType(val);
    if (val === 'RANGE') {
      setData(['', '']);
      changeData({ opValue: handleData('', ''), opType: val, opDescValue: '区间' }); // opDescValue拿到所选择的所有值的中文释义
    } else if (val === 'RANGEGT') {
      setData(['0', '']);
      changeData({ opValue: handleData(''), opType: val, opDescValue: '大于等于' });
    } else {
      // 小于等于，下限为0
      setData(['0', '']);
      changeData({ opValue: handleData(''), opType: val, opDescValue: '小于等于' });
    }
  };

  /**
   * 选择时改变也要处理成数组形式
   */
  const changeValue = ({ opValue, index }) => {
    let opDescvalue =
      type === 'RANGE' ? '区间' : type === 'RANGEGT' ? '大于等于' : '小于等于';
    if (opValue !== '' && opValue !== undefined) {
      // 执行删除操作时，传过来的值会是 undefined
      const arr = [...data];
      const temp = opValue.toString();
      arr[index] = temp;
      const opDescArr = arr;
      opDescvalue = type === 'RANGE' ? `${opDescvalue}${opDescArr}` : `${opDescvalue}${opValue}`
      setData(arr);
      changeData({
        opValue: handleData(arr[0], arr[1]),
        opType: type,
        opDescValue: opDescvalue,
        checkContent: true,
      });
    } else if (!opValue) {
      const arr = [...data];
      arr[index] = '';
      setData(arr);
      changeData({
        opValue: handleData(arr[0], arr[1]),
        opType: type,
        opDescValue: opDescvalue,
        checkContent: true,
      });
    }
  };

  /**
   * @description: 针对数量和金额的不同类型，需要对值做倍数的不同处理，如果是金额，需要把输入时乘的100倍再除回去
   * @param {*} val
   * @return {*}
   */
  const returnVal = (val) => {
    return Number(val);
  };

  const numMax = 999999999; // 数字类型的最大区间

  return (
    <div className={`${styles['tag-section']} ${styles['tag-width']}`}>
      <Select
        followTrigger
        value={type}
        onChange={(val) => changeType(val)}
        className="tag-type-select"
      >
        {sectionType.map((its, ins) => (
          <Select.Option key={`${its.label}${ins}`} value={its.key}>
            {its.label}
          </Select.Option>
        ))}
      </Select>
      {type === 'RANGE' ? (
        <>
          <NumberPicker
            min={0}
            max={numMax}
            precision={0}
            value={data[0] ? returnVal(data[0]) : null}
            onChange={(opValue) => changeValue({ opValue, index: 0 })}
          />
          <span> -- </span>
          <NumberPicker
            min={0}
            max={numMax}
            precision={0}
            value={data[1] ? returnVal(data[1]) : null}
            onChange={(opValue) => changeValue({ opValue, index: 1 })}
          />
        </>
      ) : (
        <NumberPicker
          min={0}
          max={numMax}
          precision={0}
          value={data[1] ? returnVal(data[1]) : null}
          onChange={(opValue) => changeValue({ opValue, index: 1 })}
        />
      )}
      {!data.every((item) => {
          return item.length > 0;
        }) && (
          <div style={{ color: "#f33" }}
            className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
          >
            请输入{tagItem.labelDescription}
          </div>
        )}
    </div>
  );
};
export default TagSection;
